// Let's stock all the checkers and other reusable function in here

export const isValidJson = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
